"use client";
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import ProfileSection from "@/modules/customer/pages/ProfileSection/ProfileSection";
import DocumentsSection from "@/modules/customer/pages/DocumentsSection/DocumentsSection";
import TwoFactorAuth from "@/modules/customer/components/TwoFactorAuth";
// import PrivacyPolicySection from "@/modules/customer/pages/PrivacyPolicySection";
// import HelpSection from "@/modules/customer/pages/HelpSection";

const tabLabels = [
  "Personal Details",
  "Documents",
  "Two-Factor Auth",
  "Privacy & Policy",
  "Help",
];

const SettingSection = () => {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const navigate = useNavigate();

  // Handle URL parameters to set active tab
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tab = urlParams.get('tab');
    
    if (tab === 'two_factor') {
      setActiveTab(2); // Two-Factor Auth tab
    }
  }, [location.search]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    
    // Remove tab=two_factor parameter when switching to other tabs
    if (newValue !== 2) { // 2 is the TwoFactorAuth tab index
      const urlParams = new URLSearchParams(location.search);
      urlParams.delete('tab');
      const newSearch = urlParams.toString();
      const newUrl = newSearch ? `${location.pathname}?${newSearch}` : location.pathname;
      navigate(newUrl, { replace: true });
    }
  };

  const renderActiveTabContent = () => {
    // Only render the active component to prevent unnecessary API calls
    switch (activeTab) {
      case 0:
        return <ProfileSection />;
      case 1:
        return <DocumentsSection />;
      case 2:
        return <TwoFactorAuth />;
      // case 3:
      //   return <PrivacyPolicySection />;
      // case 4:
      //   return <HelpSection />;
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        mt: '10px',
        pl:'10px',
        display: "flex",
        flexDirection: "column",
        fontFamily: "Poppins, -apple-system, Roboto, Helvetica, sans-serif",
        height: "98%", // 👈 Add this line
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          color: "#5e5acf",
        }}
      >
        Settings
      </Typography>

      <Paper
        elevation={isMobile ? 0 : 3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: isMobile ? "8px" : "16px 0 0",
          border: isMobile ? "none" : "1px solid #cdccf0",
          padding: isMobile ? "20px" : "0px 42px 50px",
          boxShadow: isMobile ? "none" : "14px 28px 45px #7090b033",
          width: "100%",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant={isMobile ? "scrollable" : "standard"}
          scrollButtons={isMobile ? "auto" : false}
          textColor="primary"
          indicatorColor="primary"
          sx={{
            borderBottom: "2px solid #ddd",
            fontSize: isMobile ? "16px" : "20px",
            "& .MuiTab-root": {
              minWidth: isMobile ? 100 : 150,
              textTransform: "none",
              fontWeight: 600,
              padding: isMobile ? "8px 12px" : "10px 20px",
            },
            "& .Mui-selected": {
              color: "#5e5acf",
              fontWeight: "bold",
            },
            "& .MuiTabs-indicator": {
              height: isMobile ? "2px" : "3px",
              backgroundColor: "#5e5acf",
            },
          }}
        >
          {tabLabels.map((label, index) => (
            <Tab key={label} label={label} />
          ))}
        </Tabs>

        <React.Fragment>{renderActiveTabContent()}</React.Fragment>
      </Paper>
    </Box>
  );
};

export default SettingSection;
